import { apiService } from "@blacknut/javascript-sdk/dist";
import { ProfilePinProps } from "@blacknut/react-sdk";
import { Pin, SingleInputPin } from "@blacknut/react-sdk/dist";
import React from "react";
const PinFactory = (props: ProfilePinProps) => {
  if (apiService.userAgent.deviceType === "TV") {
    return <SingleInputPin {...props} />;
  }
  return <Pin {...props} />;
};

export { PinFactory };
